import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Button } from 'shared/ui/button'

import exitBookingImage from './exit-booking.webp'
import s from './styles.module.scss'

interface Props {
  onContinue: () => void
  onExit: () => void
}

export const ExitBookingModal: FC<Props> = ({ onContinue, onExit }) => {
  const { t } = useTranslation()

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="exit-booking-title"
      aria-describedby="exit-booking-description"
      className={s.container}
    >
      <img
        src={exitBookingImage}
        alt=""
        width={100}
        height={95}
      />

      <div className={s.text}>
        <p
          id="exit-booking-title"
          className={clsx('bold-20', s.title)}
        >
          {t('purchase_page.exit_confirmation.title')}
        </p>

        <p
          id="exit-booking-description"
          className={clsx('regular-14', s.description)}
        >
          {t('purchase_page.exit_confirmation.description')}
        </p>
      </div>

      <div className={s.buttons}>
        <Button
          type="button"
          className={clsx('bold-17', s.button)}
          onClick={onContinue}
        >
          {t('purchase_page.exit_confirmation.continue')}
        </Button>

        <Button
          type="button"
          variant="transparentBlue"
          borderRadius="md"
          className={clsx('bold-17', s.button)}
          onClick={onExit}
        >
          {t('purchase_page.exit_confirmation.exit')}
        </Button>
      </div>
    </div>
  )
}
